import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f17f663"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "短信接入方名称：", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "短信平台：", -1));
const _hoisted_7 = {
  style: {
    "width": "300px"
  }
};
const _hoisted_8 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import SmsSecret from './components/SmsSecret';
import { getSmsUserConfigPage, delSmsUserConfig } from '@/api/sms';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas, PLATFORM_TYPE, platformOptions } from './config';
import { useRouter } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    // loading效果
    const loading = ref(false);
    const appName = ref('');
    const platform = ref('');
    const handlePlatformChange = e => {
      platform.value = e;
    };
    /**
     * 获取短信接入方密钥分页
     */
    const getData = async () => {
      loading.value = true;
      try {
        const res = await getSmsUserConfigPage({
          currentPage: currentPage.value,
          pageSize: pageSize.value,
          platform: platform.value,
          appName: appName.value
        });
        // console.log(res)
        tableData.value = res.records;
        setCurrentPage(res.current);
        setTotal(res.total);
        console.log('total.value:', total.value);
        loading.value = false;
      } catch (error) {
        console.log('error:', error);
        loading.value = false;
      }
    };
    getData();

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };

    /** 新增飞书应用 */
    const addVisible = ref(false);
    const handleAddRow = () => {
      addVisible.value = true;
    };
    const current = ref(null);
    const handleUpdate = row => {
      current.value = row;
      handleAddRow();
    };
    const clearCurrent = () => {
      current.value = null;
    };
    const handleDel = row => {
      ElMessageBox.confirm('是否删除该短信密钥管理信息', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delSmsUserConfig({
          id: row.id,
          appId: row.appId
        });
        await getData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    const router = useRouter();
    const handleJumpSmsModule = row => {
      router.push(`/operation/smsSecretManage/moduleManage/${row.appId}?platform=${row.platform}`);
    };
    const handleJumpSmsSign = row => {
      router.push({
        path: `/operation/smsSecretManage/signManage/${row.appId}`
      });
    };

    /** 跳转短信发送记录 */
    const handleJumpSmsRecord = row => {
      router.push({
        path: `/operation/smsSecretManage/signRecordManage/${row.appId}`
      });
    };
    const handleRefreshActivity = () => {
      platform.value = '';
      appName.value = '';
      currentPage.value = 1;
      getData();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
          modelValue: appName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => appName.value = $event),
          placeholder: "请输入短信接入方名称",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue"]), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_select, {
          modelValue: platform.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => platform.value = $event),
          class: "m-2",
          placeholder: "选择短信平台",
          onChange: handlePlatformChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['smsSecretAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: item.label,
              "min-width": item.minWidth
            }, {
              default: _withCtx(({
                row
              }) => [item.prop !== 'platform' ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(row[item.prop]), 1)) : _createCommentVNode("", true), item.prop === 'platform' ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(PLATFORM_TYPE)[row[item.prop]]), 1)) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "400"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "info",
              size: "small",
              onClick: $event => handleJumpSmsModule(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 模板管理 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['smsModuleManage']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "success",
              size: "small",
              onClick: $event => handleJumpSmsSign(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 签名管理 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['smsSignManage']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "warning",
              size: "small",
              onClick: $event => handleJumpSmsRecord(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 发送记录 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['smsRecordManage']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleUpdate(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['smsSecretUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['smsSecretDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(SmsSecret), {
        modelValue: addVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addVisible.value = $event),
        model: current.value,
        onRefreshData: getData,
        onClearModel: clearCurrent
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};